/* unplugin-vue-components disabled */import { ElCheckbox as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/checkbox/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/img/如何成为CIFA.png';
import _imports_1 from '../assets/img/如何成为CWA.png';
import _imports_2 from '../assets/img/如何报名考试.png';
import _imports_3 from '../assets/img/如何申请证书.png';
import _imports_4 from '../assets/img/CIFA备考指南.png';
import _imports_5 from '../assets/img/CIFA考试大纲.png';
import _imports_6 from '../assets/img/CWA备考指南.png';
import _imports_7 from '../assets/img/CWA考试大纲.png';
import _imports_8 from '../assets/img/微信.png';
import _imports_9 from '../assets/img/电子邮件.png';
import _imports_10 from '../assets/img/地址.png';
var _hoisted_1 = {
  "class": "f-top"
};
var _hoisted_2 = {
  "class": "f-top-content"
};
var _hoisted_3 = {
  "class": "right-content"
};
var _hoisted_4 = {
  "class": "f-bottom"
};
var _hoisted_5 = {
  "class": "f-bottom-content"
};
import { saveInformationApi } from '@/api/footer';
import router from '@/router';
export default /*@__PURE__*/_defineComponent({
  __name: 'FooterViews',
  setup: function setup(__props) {
    var formData = ref({
      email: ''
    });
    var checked = ref(false);
    function submit() {
      if (formData.value.email === '') {
        ElMessage.error('请输入电子邮箱');
      } else {
        checked.value = true;
        saveInformationApi(formData.value).then(function (res) {
          if (res.code === 200) {
            ElMessage.success(res.msg);
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    }
    return function (_ctx, _cache) {
      var _component_el_button = __unplugin_components_0;
      var _component_el_checkbox = __unplugin_components_1;
      var _component_spanv = _resolveComponent("spanv");
      return _openBlock(), _createElementBlock("footer", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[8] || (_cache[8] = _createStaticVNode("<div class=\"left-content\" data-v-18f0d6c4><ul data-v-18f0d6c4><li data-v-18f0d6c4>考试信息</li><li data-v-18f0d6c4><img src=\"" + _imports_0 + "\" alt=\"\" srcset=\"\" data-v-18f0d6c4><span data-v-18f0d6c4>如何成为CIFA</span></li><li data-v-18f0d6c4><img src=\"" + _imports_1 + "\" alt=\"\" srcset=\"\" data-v-18f0d6c4><span data-v-18f0d6c4>如何成为CWA</span></li><li data-v-18f0d6c4><img src=\"" + _imports_2 + "\" alt=\"\" srcset=\"\" data-v-18f0d6c4><span data-v-18f0d6c4>如何报名考试</span></li><li data-v-18f0d6c4><img src=\"" + _imports_3 + "\" alt=\"\" srcset=\"\" data-v-18f0d6c4><span data-v-18f0d6c4>如何申请证书</span></li></ul><ul data-v-18f0d6c4><li data-v-18f0d6c4>资料下载</li><li data-v-18f0d6c4><img src=\"" + _imports_4 + "\" alt=\"\" srcset=\"\" data-v-18f0d6c4><span data-v-18f0d6c4>CIFA备考指南</span></li><li data-v-18f0d6c4><img src=\"" + _imports_5 + "\" alt=\"\" srcset=\"\" data-v-18f0d6c4><span data-v-18f0d6c4>CIFA考试大纲</span></li><li data-v-18f0d6c4><img src=\"" + _imports_6 + "\" alt=\"\" srcset=\"\" data-v-18f0d6c4><span data-v-18f0d6c4>CWA备考指南</span></li><li data-v-18f0d6c4><img src=\"" + _imports_7 + "\" alt=\"\" srcset=\"\" data-v-18f0d6c4><span data-v-18f0d6c4>CWA考试大纲</span></li></ul></div>", 1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [_cache[6] || (_cache[6] = _createElementVNode("li", null, "想获取更多CIFA和CWA认证信息？", -1)), _cache[7] || (_cache[7] = _createElementVNode("li", null, "提交邮箱，我们将为您定期发送关于职业认证最新资讯", -1)), _createElementVNode("li", null, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _unref(formData).email = $event;
        }),
        placeholder: "输入电子邮件地址"
      }, null, 512), [[_vModelText, _unref(formData).email]]), _createVNode(_component_el_button, {
        onClick: submit
      }, {
        "default": _withCtx(function () {
          return _cache[4] || (_cache[4] = [_createTextVNode("提交")]);
        }),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_el_checkbox, {
        modelValue: _unref(checked),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(checked) ? checked.value = $event : null;
        }),
        size: "large"
      }, null, 8, ["modelValue"]), _cache[5] || (_cache[5] = _createTextVNode("我愿意接收来自IIFA的邮件，并遵守IIFA相关服务协议和隐私政策 "))])])])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("div", null, [_createElementVNode("p", null, [_createElementVNode("span", {
        style: {
          "cursor": "pointer"
        },
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _unref(router).push('/agreement');
        })
      }, "服务协议"), _createVNode(_component_spanv, {
        style: {
          "margin": "0 10px"
        }
      }, {
        "default": _withCtx(function () {
          return _cache[9] || (_cache[9] = [_createTextVNode("|")]);
        }),
        _: 1
      }), _createElementVNode("span", {
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _unref(router).push('/privacy');
        }),
        style: {
          "cursor": "pointer"
        }
      }, "隐私政策")]), _cache[10] || (_cache[10] = _createElementVNode("p", null, [_createElementVNode("img", {
        src: _imports_8,
        alt: ""
      }), _createElementVNode("span", null, "微信:iifachina5")], -1))])]), _cache[11] || (_cache[11] = _createElementVNode("li", null, [_createElementVNode("div", null, [_createElementVNode("p", null, "@2020-2025, Beijing Authorized Representative Office of llFA"), _createElementVNode("p", null, [_createElementVNode("img", {
        src: _imports_9,
        alt: ""
      }), _createElementVNode("span", null, "邮箱:iifachina@iifa.org.cn")])])], -1)), _cache[12] || (_cache[12] = _createElementVNode("li", null, [_createElementVNode("div", null, [_createElementVNode("p", null, "版权所有 IIFA中国培训与认证管理中心(华菁教育)"), _createElementVNode("p", null, [_createElementVNode("img", {
        src: _imports_10,
        alt: ""
      }), _createElementVNode("span", null, "地址:北京市大兴区新源大街29号院")])])], -1)), _cache[13] || (_cache[13] = _createElementVNode("li", null, [_createElementVNode("span", null, "京ICP备2024063674号-5 | 增值电信业务经营许可证: 京B2-20241537")], -1))])])])]);
    };
  }
});